import React, { useState, useEffect } from "react";
import { Medal, Award, Coins } from "lucide-react";
import { SectionHeader } from "./Rates";
import api from "../lib/api";

const rankIcon = (rank) => {
  if (rank === "gold") return <Medal className="text-gold" size={22} />;
  if (rank === "silvermedal") return <Award className="text-gray-300" size={22} />;
  return <Coins className="text-gray-400" size={20} />;
};

const HallOfFame = () => {
  const [winners, setWinners] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [tab, setTab] = useState("");

  useEffect(() => {
    api.get("/winners").then((r) => setWinners(r.data)).catch(() => {});
    api.get("/winners/periods").then((r) => {
      setPeriods(r.data);
      if (r.data.length) setTab(r.data[0]);
    }).catch(() => {});
  }, []);

  const rows = winners.filter((w) => `${w.month} ${w.year}` === tab);

  return (
    <section id="winners" className="relative py-24 bg-[#0b0f19]">
      <div className="max-w-[1000px] mx-auto px-6 md:px-8">
        <SectionHeader eyebrow="Hall of Fame" title="Monthly Draw Winners" sub="Every month, lucky members take home gold & silver. Congratulations to all our winners!" />

        <div className="flex justify-center flex-wrap gap-3 mb-8">
          {periods.map((p) => (
            <TabBtn key={p} active={tab === p} onClick={() => setTab(p)}>{p}</TabBtn>
          ))}
        </div>

        <div className="border border-white/8 bg-white/[0.02] overflow-hidden">
          <div className="grid grid-cols-[48px_1fr_1fr_120px] md:grid-cols-[64px_1fr_1fr_140px] bg-white/[0.03] border-b border-white/8 px-4 py-3 font-ui text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
            <span>#</span><span>Winner Name</span><span>Prize Won</span><span className="text-right">Category</span>
          </div>
          <div className="max-h-[520px] overflow-y-auto divide-y divide-white/5">
            {rows.length === 0 && (
              <div className="px-4 py-10 text-center font-body italic text-gray-500">No winners listed for this period yet.</div>
            )}
            {rows.map((w, i) => (
              <div key={w.id || i} className="grid grid-cols-[48px_1fr_1fr_120px] md:grid-cols-[64px_1fr_1fr_140px] items-center px-4 py-3.5 hover:bg-gold/[0.04] transition-colors">
                <span>{rankIcon(w.rank)}</span>
                <span className="font-display text-lg text-white truncate pr-2">{w.name}</span>
                <span className="font-body text-gray-300 text-sm truncate pr-2">{w.prize}</span>
                <span className="text-right">
                  <span className={`font-ui text-[9px] tracking-wider uppercase px-2.5 py-1 ${w.cat === '24K Gold' ? 'bg-gold/10 text-gold' : 'bg-white/8 text-gray-300'}`}>{w.cat}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
        <p className="font-body italic text-center text-gray-500 text-sm mt-6">Winners are shown by name or member number · 32 winners every month.</p>
      </div>
    </section>
  );
};

const TabBtn = ({ active, onClick, children }) => (
  <button onClick={onClick}
    className={`font-ui text-[11px] tracking-[0.2em] uppercase px-6 py-3 border transition-colors ${active ? "gold-btn border-transparent" : "border-white/15 text-gray-300 hover:border-gold hover:text-gold"}`}>
    {children}
  </button>
);

export default HallOfFame;
